import { getAdminSuspensionsListQueryOptions } from "@sidegigllc/api/client";
import { adminProQueryOptions } from "api/queries/admin";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { proId: number };

export const suspensionsQuery = ({ proId }: QueriesInput) => getAdminSuspensionsListQueryOptions({ pro_id: proId });

export const queries = (input: QueriesInput): Array<WarmableQuery> => [
  adminProQueryOptions(input.proId),
  suspensionsQuery(input),
];
